const html = require("./html/asnShippingPalletRowView.html");
import render from "../../../utilities/render";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import {setElementsFromScope, insertValAndManageFocus, show, hide, handleDisplayFor, setCheckboxState, enableInput, disableInput, setRequired, setUniqNamesAndIds, setDisabled} from "../../../utilities/selectorHelpers";
import _ from "underscore";

const elementsMap = {
  asnDetailLength: ".asn-detail-length",
  asnDetailWidth: ".asn-detail-width",
  asnDetailHeight: ".asn-detail-height",
  asnDetailWeight: ".asn-detail-weight",
  palletCaseIdx: ".pallet-case-idx",
  palletCaseLabel: ".pallet-case-label",
  stackablePalletOuter: ".stackable-pallet-outer",
  stackablePalletCheckbox: ".stackable-pallet-checkbox",
  shippingTabSkus: ".shipping-tab-prd-skus",
  prdLevelPalletCaseLabel: ".prd-level-pallet-case-label",
  palletCaseNumber : ".pallet-case-number",
  applyDimensionWeightOuter : ".apply-dimension-weight-to-all-outer",
  applyDimensionToAllBtn : ".apply-to-all-btn",
  asnDetailRowsOuter: ".shipping-asn-details-rows-outer",
};

export default function AsnShippingPalletRowView(asnShippingPallet,options){

    const {rowIdx, onAsnShippingPalletFieldChange, onAsnShippingPalletsGroupFieldChange, getAsnShipppingPallets} = options;

  const asnShippingPalletId = asnShippingPallet.id;
  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    renderEl();
  };

  function bindStores(){
    AsnShippingPalletStore.bindListener(`asn_shipping_pallet:change`, updateSelf);

  }

  self.unbindListeners = function(){
    AsnShippingPalletStore.unbindListener(`asn_shipping_pallet:change`, updateSelf);

  };

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setUniqueIdForStackble(){
    const checkBox = self._element.find(".stackable-pallet-checkbox-container");
    checkBox.find("input").attr("id","shipping-pallet-stackable"+rowIdx);
    checkBox.find("input").attr("name","shipping-pallet-stackable"+rowIdx);
    checkBox.find("label").attr("for","shipping-pallet-stackable"+rowIdx);
  }


  function renderEl(){
    //self._element = $(html);
    const asnShippingPallet = getAsnShippingPallet(asnShippingPalletId);
    self._element = $(render(html,{rowIdx, asnShippingPalletId, palletData:asnShippingPallet}));
      
    setElements();
    setUniqueIdForStackble();
    setUniqNamesAndIds([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
    setRequired([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
   
    //bindElements();
    bindStores();
    update();
  }

  function update(){
    // handle rendering children
    updateSelf();
  }

    function updateSelf(){
    // handle updating values;
    updateValues();
    updatePalletCaseIdx();
    updatePalletCaseLabel();
    updatePalletSpecificFields();
    updateNumberOfCasePallet();
    setApplyDimensionWeightBtn();
  }

  function updatePalletCaseIdx(){
    els.palletCaseIdx.text(rowIdx + 1);
  }

  function updatePalletCaseLabel(){
    els.palletCaseLabel.text("Pallet");
    $(els.prdLevelPalletCaseLabel).html("Pallet");
  }

  function updatePalletSpecificFields(){
    handleDisplayFor(els.stackablePalletOuter, true);
  }

  function updateNumberOfCasePallet(){
    $.each(getAsnShipppingPallets(),function(index,object){
      $(els.palletCaseNumber).html(object.numberOfPallets);
  });
  }

    function getAsnShippingPallet(asnShippingPalletId){
    return AsnShippingPalletStore.getAsnShippingPallet(asnShippingPalletId);
  }

  function setApplyDimensionWeightBtn(){
   if(rowIdx == 0)
   {
    show(els.applyDimensionWeightOuter);
   }
   else
   {
     hide(els.applyDimensionWeightOuter);
   }
  }

  function updateValues(){
    const asnShippingPallet = getAsnShippingPallet(asnShippingPalletId);
    insertValAndManageFocus(els.asnDetailLength, asnShippingPallet.asp_pallet_length);
    insertValAndManageFocus(els.asnDetailWidth, asnShippingPallet.asp_pallet_width);
    insertValAndManageFocus(els.asnDetailHeight, asnShippingPallet.asp_pallet_height);
    insertValAndManageFocus(els.asnDetailWeight, asnShippingPallet.asp_pallet_weight);
    setCheckboxState(els.stackablePalletCheckbox, asnShippingPallet.asp_pallet_stackable);
  }
  
  self.getElement = function(){
    return self._element;
  }


}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/AsnShippingPalletRowView.js